import Button from './Button'
import styled from 'styled-components'

export default styled(Button)``
